import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
// import { map } from 'rxjs/operators';

let org: any = "";
@Injectable({
  providedIn: "root",
})
export class UtilityService {
  constructor(private http: HttpClient) {}

  imgCollection = [
    {
      image:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/beauty+lifestyle+and+wellness/Massage+Specialist+Massues.jpg",
      thumbImage:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/beauty+lifestyle+and+wellness/Massage+Specialist+Massues.jpg",
      alt: "Beauty, Lifestyle & Wellness",
      title: "Beauty, Lifestyle & Wellness",
      desc: `
      <p>
      To begin, the realms of beauty and wellness have a lot of overlap. Being well can help you look beautiful and feeling beautiful can increase your overall wellness.
      </p>
      <br>
      <p>
      What is beauty to you? How you feel and how you look can have a lot to do with one another. Taking care of one area can often lead to benefits in the other. Beauty and wellness may not have clearly defined lines that divide them, but they both have pretty clearly defined benefits that connect them
      </p>
      `,
    },
    {
      image:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/roadside+assist/mechanic.jpg",
      thumbImage:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/roadside+assist/mechanic.jpg",
      title: "Roadside Assist",
      alt: "Roadside Assist",
      desc: `
      <p>
      We provide professional services designed to help drivers make minor mechanical repairs and adjustments to broken down vehicles. There are so many things that can go wrong with a vehicle. 
      </p>
      <br>
      <p>
      Whether it is a flat tire or dead battery, if you cannot drive your vehicle for any reason, either you have to fix the problem yourself or you can call a roadside assistance service to restore your car. 
      </p>
      
      `,
    },
    {
      image:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/minding+services/Physically+challenged.jpg",
      thumbImage:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/minding+services/Physically+challenged.jpg",
      title: "Minding Services",
      alt: "Minding Services",
      desc: `
      <p>
      The range of home health care services a patient can receive at home is limitless. Depending on the individual patient's situation, care can range from nursing care to specialized medical services, such as laboratory workups. You and your minder will determine your care plan and services you may need at home.
      </p>
      <br>
      <p>
      Our services include:
      <br>
      •	Child minding <br>
      •	Elderly minding  <br>
      •	The physically challenged  <br>
      •	Executive services  <br>
      •	Pet care  <br>
      
      </p>
      `,
    },
    {
      image:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/security+protocol/VIP++Executive+Protection..jpg",
      thumbImage:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/security+protocol/VIP++Executive+Protection..jpg",
      title: "Security/ Protocol",
      alt: "Security/ Protocol",
      desc: `
      <p>
      Need personal, event or VIP protection? Need to install surveillance systems? We got you covered. We have highly vetted professionals at your service!
      </p>
      
      `,
    },
    {
      image:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/cleaning/After+Builders+Cleaning.jpg",
      thumbImage:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/cleaning/After+Builders+Cleaning.jpg",
      title: "Cleaning, Pest Control & Removals",
      alt: "Cleaning, Pest Control & Removals",
      desc: `
      <p>
      A cleaner environment supports a healthier, more productive and profitable lifestyle; that is why our thorough cleaning service is made to leave you happier and more satisfied.
      Our providers are here to exhibit extreme professionalism and commitment to your taste and satisfaction      
      </p>
      `,
    },
    {
      image:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/fitness/gym-instructors-fitness.jpg",
      thumbImage:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/fitness/gym-instructors-fitness.jpg",
      title: "Fitness",
      alt: "Fitness",
      desc: `
      <p>
      Do you really want to get back in shape or do you have a reoccurring pain on any part of your body that a regular workout/exercise can help heal or ease or you just need someone to workout with?
      </p>
      <br>
      <p>
      Achieving the fitness results you want can sometimes feel overwhelming with so many experts giving advice on diet, exercise, and even sleep.
      </p>
      <br>
      <p>
      Our experts offer private home workout services that are tailored specifically to your needs and our fitness routines are suitable for men and women of all ages
      </p>
      `,
    },
    {
      image:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/education/Home+Tutors.jpg",
      thumbImage:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/education/Home+Tutors.jpg",
      title: "Education & Tutoring",
      alt: "Education & Tutoring",
      desc: `
      <p>
      Here we try to provide private/personal services at your doorstep. Be it home tutoring, driving instructors or even cooking classes, we have them all
      </p>
     
      `,
    },
    {
      image:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/trades+odd+jobs/funniture+assembly.jpg",
      thumbImage:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/trades+odd+jobs/funniture+assembly.jpg",
      title: "Trades & Odd jobs",
      alt: "Trades & Odd jobs",
      desc: `
      <p>
      All of our Handymen are fully qualified, carefully chosen and they are capable of carrying out a variety of services from Painting & Decorating, Plumbing, Carpentry, Tiling & Grouting, Electrical & Wiring and much, much more.
      </p>
      
      `,
    },
    {
      image:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/tech/computer+repairs.jpg",
      thumbImage:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/tech/computer+repairs.jpg",
      title: "Tech",
      alt: "Tech",
      desc: `
      <p>
      Technology services are professional services designed to facilitate the use of technology by enterprises and end users. Technology services provide specialized technology-oriented solutions by combining the processes and functions of software, hardware, networks, telecommunications and electronics.
      </p>
      <br>
      <p>
      Services are delivered according to business or enterprise requirements. Services range from basic Internet connectivity to enterprise application (EA) software. Technology service providers include Internet service providers (ISP), application service providers (ASP), cloud providers and developers.
      </p>
      <br>
      <p>
      These services include: <br>
      •	Software development, integration and maintenance <br>
      •	Hardware  <br>
      •	Networking integration, management and maintenance  <br>
      •	Information security (IS)  <br>
      •	IT management consultants  <br>
      •	Mobile services  <br>
      •	Web applications   <br>     
      </p>
      `,
    },
    {
      image:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/entertainment/Event+Planners.jpg",
      thumbImage:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/entertainment/Event+Planners.jpg",
      title: "Entertainment",
      alt: "Entertainment",
      desc: `
      <p>
      Entertainment is a form of activity that holds the attention and interest of an audience or gives pleasure and delight. It can be an idea or a task, but is more likely to be one of the activities or events that have developed over thousands of years specifically for the purpose of keeping an audience's attention
      </p>
     
      `,
    },

    {
      image:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/gardening+and+landscapping/Garden+Maintenance.jpg",
      thumbImage:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/gardening+and+landscapping/Garden+Maintenance.jpg",
      title: "Gardening & Landscaping",
      alt: "Gardening & Landscaping",
      desc: `
      <p>
      We provide services for residential lawns as well as company grounds and offer a wide array of services, such as designing and installing landscape features, holiday decorations and more.
      </p>
      <p>
      Services also include basic gardening tasks, such as planting perennials, annuals, shrubs, and trees, lawn and garden maintenance services like mowing, pruning, and fertilizing, as well as disposal services, like removing brush and other debris.
      </p>
     
      `,
    },
    {
      image:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/locksmith/lock+fixing+%26+repairing.jpg",
      thumbImage:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/locksmith/lock+fixing+%26+repairing.jpg",
      title: "Locksmith",
      alt: "Locksmith",
      desc: `
      <p>
      Locksmith services include emergency call outs, key cutting, changing locks, repairs to auto locksmiths helping with lost car keys & replacement keys.  All locksmiths approved by the Jobbersnest are fully vetted, inspected & qualified.
      </p>
     
      `,
    },
    {
      image:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/property+inventory+services/floor+planning.jpg",
      thumbImage:
        "https://Jobbersnest.s3.eu-west-2.amazonaws.com/property+inventory+services/floor+planning.jpg",
      title: "Property Renovations & Inventory Services",
      alt: "Property Renovations & Inventory Services",
      desc: `
      <p>
      Your home refurbishment service is handled by tradesmen who are experienced and fully dedicated to their field of work. They also carry public liability insurance which means that any issue that might happen during your service will be covered.
      </p>
      <p>
      The renovation expert team will bring all necessary tools and equipment to complete your service. From ladders of various sizes to a wide range of manual and power tools, the experts are fully geared up to handle your property’s overhaul.
      </p>
     
      `,
    },
  ];
}
